module.exports = __webpack_public_path__ + "img/91-thickbox_default.d1f02aef.jpg";